<div class="overview-table-height">
	<div class="c-portlet u-bg-main u-shadow-mini pos-relative">
		<app-loader [showLoader]="showLoad"></app-loader>
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom primary-color-bg"
		>
			<div class="o-stack__cell">
				<h5>Overview</h5>
			</div>
		</div>
		<div class="c-portlet__content">
			<table>
				<thead>
					<tr>
						<th style="text-align: left; padding-left: 1em;"><span class="table-header_label">Product</span></th>
						<th><span class="table-header_label">Impressions</span></th>
						<th><span class="table-header_label">Clicks</span></th>
						<th><span class="table-header_label">View Throughs</span></th>
						<th><span class="table-header_label">Visits</span></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let summaryObj of summaryData; let i = index" class="header-level">
						<td
							class="{{ summaryObj.parentClass }}"
							[ngStyle]="{ 'font-weight': i == summaryData.length - 1 ? '600' : 'normal' }"
							[ngClass]="{
								'display-header_border overview-header': summaryObj.isParent,
								'display-subHead_border overview-subheader': !summaryObj.isParent
							}"
						>
							<span [innerHtml]="summaryObj.productName"></span>
						</td>
						<td
							[ngStyle]="{ 'font-weight': i == summaryData.length - 1 ? '600' : 'normal' }"
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="!isNaN(summaryObj.impressions) && summaryObj.impressions > 0; else impressionsBlock">{{
								summaryObj.impressions | number
							}}</span>
							<ng-template #impressionsBlock>
								<span>n/a</span>
							</ng-template>
						</td>
						<td
							[ngStyle]="{ 'font-weight': i == summaryData.length - 1 ? '600' : 'normal' }"
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="!isNaN(summaryObj.clicks) && summaryObj.clicks > 0; else clicksBlock">
								<span
									appTooltip
									title="Tooltip"
									[title]="'Click Rate : ' + summaryObj.clickRate"
									data-size="big"
									[options]="tooltipOptions"
								>
									{{ summaryObj.clicks | number }}
								</span>
							</span>
							<ng-template #clicksBlock>
								<span appTooltip title="Tooltip" [title]="'Click Rate : n/a'" data-size="big" [options]="tooltipOptions"
									>n/a</span
								>
							</ng-template>
						</td>
						<td
							[ngStyle]="{ 'font-weight': i == summaryData.length - 1 ? '600' : 'normal' }"
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="!isNaN(summaryObj.viewThroughs) && summaryObj.viewThroughs > 0; else viewThroughBlock">
								<span
									appTooltip
									title="Tooltip"
									[title]="'View Through Rate : ' + summaryObj.viewThroughRate"
									data-size="big"
									[options]="tooltipOptions"
								>
									{{ summaryObj.viewThroughs | number }}
								</span>
							</span>
							<ng-template #viewThroughBlock>
								<span
									appTooltip
									title="Tooltip"
									[title]="'View Through Rate : n/a'"
									data-size="big"
									[options]="tooltipOptions"
									>n/a</span
								>
							</ng-template>
						</td>
						<td
							[ngStyle]="{ 'font-weight': i == summaryData.length - 1 ? '600' : 'normal' }"
							[ngClass]="{
								'table-header_label overview-header': summaryObj.isParent,
								'overview-subheader': !summaryObj.isParent
							}"
						>
							<span *ngIf="!isNaN(summaryObj.visits) && summaryObj.visits > 0; else visitsBlock">
								<span
									appTooltip
									title="Tooltip"
									[title]="'Visit Rate : ' + summaryObj.visitRate"
									data-size="big"
									[options]="tooltipOptions"
								>
									{{ summaryObj.visits | number }}
								</span>
							</span>
							<ng-template #visitsBlock>
								<span appTooltip title="Tooltip" [title]="'Visit Rate : n/a'" data-size="big" [options]="tooltipOptions"
									>n/a</span
								>
							</ng-template>
						</td>
					</tr>
					<tr *ngIf="summaryData.length == 0">
						<td colspan="5" style="height: 504px;">
							<span>No Data to Display</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
